import { render, staticRenderFns } from "./minrent.vue?vue&type=template&id=1820832a&scoped=true&"
import script from "./minrent.vue?vue&type=script&lang=js&"
export * from "./minrent.vue?vue&type=script&lang=js&"
import style0 from "./minrent.vue?vue&type=style&index=0&id=1820832a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1820832a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1820832a')) {
      api.createRecord('1820832a', component.options)
    } else {
      api.reload('1820832a', component.options)
    }
    module.hot.accept("./minrent.vue?vue&type=template&id=1820832a&scoped=true&", function () {
      api.rerender('1820832a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2f2Vw4Re9aES2/JS/comp/minrent.vue"
export default component.exports